import { Link, useLocation } from "react-router-dom"

const navigation = {
    main: [
      { name: 'Home', href: '/' },
      { name: 'Contact', href: '/contact' },
      { name: 'Blog', href: '/blog' },
      // { name: 'Testimonials', href: '/testimonials' },
      { name: 'Our Services', href: '/services' },
  ],
    social: [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/profile.php?id=61554670757870&mibextid=ZbWKwL',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: 'Instagram',
        href: 'https://www.instagram.com/executivehaven?igsh=MTB6YW1yOXh3NTJleg==',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: 'Linkedin',
        href: 'https://www.linkedin.com/company/executivehaven/',
        icon: (props) => (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6" aria-hidden="true">
          <path d="M2,2v20h20V2H2z M8.75,17.25H5.5V10h3.25V17.25z M7.125,9c-0.825,0-1.5-0.675-1.5-1.5c0-0.825,0.675-1.5,1.5-1.5s1.5,0.675,1.5,1.5 C8.625,8.325,7.95,9,7.125,9z M17.25,17.25h-3.25v-5c0-0.412-0.338-0.75-0.75-0.75s-0.75,0.338-0.75,0.75v5h-3.25V10h3.25v1.75 c0.553-1.031,1.928-1.775,3.5-1.775c2.525,0,4.25,1.85,4.25,5.225V17.25z"/>
        </svg>

        ),
      },
    ],
  }
  
  
  export default function Footer() {
    const location = useLocation()
    
    const handleLinkClick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    
    const isActive = (href) => {
      if (href === '/' && location.pathname === '/') return true
      if (href !== '/' && location.pathname.startsWith(href)) return true
      return false
    }
    
    return (
        <footer className="bg-gray-50">
          <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
            {/* Logo and Description */}
            <div className="text-center mb-12">
              <img
                className="h-12 w-auto mx-auto mb-6"
                src="https://admin.executivehaven.org/static/assets/img/logo.png"
                alt="Executive Haven Logo"
              />
              <p className="max-w-2xl mx-auto text-lg text-gray-600">
                Empowering businesses to unlock their full potential through expert virtual assistance and strategic support.
              </p>
            </div>

            {/* Navigation */}
            <nav className="mb-12" aria-label="Footer">
              <div className="flex flex-wrap justify-center gap-8">
                {navigation.main.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={handleLinkClick}
                    className={`px-4 py-2 rounded-lg text-base font-bold transition-all duration-200 ${
                      isActive(item.href)
                        ? 'text-white shadow-md'
                        : 'text-gray-700 hover:text-gray-900 hover:bg-gray-200'
                    }`}
                    style={isActive(item.href) ? { backgroundColor: '#3BC52B' } : {}}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </nav>

            {/* Social Links */}
            <div className="flex justify-center space-x-6 mb-12">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="p-3 rounded-full bg-white text-gray-500 shadow-md transition-all duration-300 hover:shadow-lg hover:bg-green-600 hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-5 w-5" aria-hidden="true" />
                </a>
              ))}
            </div>

            {/* CTA Section */}
            <div className="text-center mb-12 p-8 rounded-2xl bg-white shadow-lg border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Ready to Transform Your Business?
              </h3>
              <p className="text-gray-600 mb-6 max-w-xl mx-auto">
                Join hundreds of successful businesses that trust ExecutiveHaven for their growth.
              </p>
              <a
                href="https://calendly.com/admin-executivehaven/discovery-call"
                className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
                style={{ backgroundColor: "#3BC52B" }}
              >
                Schedule Your Free Consultation
                <svg className="ml-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex flex-col sm:flex-row justify-between items-center">
                <p className="text-sm text-gray-500">
                  &copy; 2025 ExecutiveHaven, Inc. All rights reserved.
                </p>
                <div className="flex space-x-6 mt-4 sm:mt-0">
                  
                </div>
              </div>
            </div>
          </div>
        </footer>
    )
  }
  